export default __webpack_public_path__ + "static/media/bulk.dae16d6e.svg";